import './post.scss'

import React, { Fragment } from 'react'
import { Post } from '../archive/Post'
import { NewsletterSubscription } from '../NewsletterSubscription/NewsletterSubscription'

const ReadMore = ({ posts }) => {
  if (!posts.length) return null

  return (
    <section className="readmore-section">
      <h4>Läs mer</h4>
      <div className="readmore-section__cards">
        {posts.slice(0, 3).map(({ relatedPost }, idx) => {
          return (
            <Fragment key={idx}>
              <Post post={relatedPost} size="small" />
            </Fragment>
          )
        })}
        <NewsletterSubscription version={'alternative'} isCta={false} />
      </div>
    </section>
  )
}

export default ReadMore
